<script setup lang="ts">
import { Contact } from "../interfaces/Contact";
defineProps<{ contact: Contact }>();
</script>

<template>
  <div class="px-6 py-1 bg-beige text-text">
    <h4 class="flex items-center">{{ contact.name }}</h4>
    <div class="contact-info flex flex-col md:flex-row text-lg">
      <div class="flex items-center w-2/5" style="min-width: 320px">
        <a href="mailto:{{contact.email}}">{{ contact.email }}</a>
      </div>
      <div class="flex items-center">{{ contact.info }}</div>
    </div>
  </div>
</template>

<style scoped>
h4 {
  text-transform: uppercase;
  font-size: 0.7em;
  font-weight: 900;
  height: 48px;
  border-bottom: 1px solid var(--border-color);
}

.contact-info {
  height: 80px;
  border-bottom: 1px solid var(--border-color);
}
</style>
